<template>
	<div class="success container">
        <div class="row">

            <div class="col-12 tc">
                <div class=" icon-master">
                    <i class="fa fa-check"></i>
                </div>
                <div class="headline h2 ">
                    <span>Vielen Dank für Deine Anfrage!</span>
                </div>
                <div class="content">
                    <p>Wir haben Deine Anfrage erhalten und melden uns innerhalb von <span>24 Stunden</span> bei Dir zurück.<br>
                        Schaue am besten auch in Deinem <span>Spam-Ordner</span> nach und höre Deine <span>Mailbox</span> ab.</p>

                    <p>Du hast vorab noch Fragen? Kein Problem! <a href="https://www.mueller-helpings.de#kontakt" title="Zum Kontaktformular">Kontaktiere uns einfach</a>.</p>
                    <br><br>
                    <a href="https://www.mueller-helpings.de/" class="button" >Zurück zur Startseite</a>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: 'success',
	components: {
        
	},

	data: function () {
        return {
            
        }
    },

    mounted: function() {

    },

    methods: {
        
    }
}
</script>

<style lang="less">
.success {
    .icon-master .fa {
        top:0;
        transform: none;
        font-size: 6rem;
        margin: none;
    }
    .content {
        p { 
            font-family: 'Voltaire', Helvetica, Arial, sans-serif;
            font-weight: 400;
            color: #000;
            font-size: 1.5rem;
        }
        span {
            font-size: 2rem;
        }
        a {
            &:before {
                display: none !important;
            }
        }
        .button {
            margin-bottom: 2rem;
        }
    }
    .container.prevnext-buttons {
        display: none;
    }
}
</style>